import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface AgencyIssuedDocument {
  name: string;
  api_token: string;
}

export interface AgencyIssuedDocumentDetaiInfor {
  errors: unknown;
  AgencyIssuedDocument: AgencyIssuedDocument;
  isAuthenticated: boolean;
}

@Module
export default class AgencyIssuedDocumentDetail
  extends VuexModule
  implements AgencyIssuedDocumentDetaiInfor
{
  errors = {};
  AgencyIssuedDocument = {} as AgencyIssuedDocument;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get AgencyIssuedDocumentDetail() {
    return this.agencyIssuedDocumentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.AGENCY_ISSUED_DOCUMENT_DETAIL_DATA](AgencyIssuedDocument) {
    this.agencyIssuedDocumentDetailData = AgencyIssuedDocument;
  }
  @Action
  [Actions.AGENCY_ISSUED_DOCUMENT_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/agency_issued_document",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.AGENCY_ISSUED_DOCUMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
